/** @typedef { import('~/api/getSparesBySearchQuery').SparePart } SparePart */

let singleton;

export default class SparePartsMap extends Map {

	constructor() {
		if (singleton)
			return singleton;

		super();
		singleton = this;

		return this;
	}

	/**
	 *
	 * @param {SparePart} part
	 */
	set(part) {
		const key = part.id;

		if (this.has(key)) {
			const storedPart = this.get(key);
			++storedPart.amount;
		} else {
			super.set(key, Object.assign({ amount: 1 }, part));
		}
	}

	/**
	 *
	 * @param {SparePart} part
	 * @param {object} obj
	 */
	update(part, obj) {
		const key = part.id;
		const storedPart = this.get(key);

		super.set(key, Object.assign({}, storedPart, obj));
	}

	/**
	 *
	 * @param {SparePart} part
	 */
	delete(part) {
		const key = part.id;

		if (!this.has(key))
			return;

		super.delete(key);
	}

	toArray() {
		const array = [];

		for (const part of this.values()) {
			array.push(Object.assign({}, part));
		}

		return array;
	}
}
